import React, { useState, useEffect } from "react";
import { policyService } from "../../Network/services/policyService";
import "./PolicyPageLoader.css";

const customStyles = {
  fontWeight: "400"
};

const PricingPolicy = () => {
  const [policyContent, setPolicyContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        setLoading(true);
        const response = await policyService.getPolicy(4);
        if (response.status === "200" && response.policy && response.policy.length > 0) {
          setPolicyContent(response.policy[0].content);
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching pricing policy:", err);
        setError("Failed to load content");
        setLoading(false);
      }
    };

    fetchPolicy();
  }, []);

  return (        
    <section className="trems-sec">
      {loading && (
        <div className="policy-page-loading-overlay">
          <div className="policy-page-spinner-container">
            <div className="policy-page-spinner"></div>
            <div className="policy-page-spinner-text">Loading...</div>
          </div>
        </div>
      )}
      <div className="container">
        {error && <div className="policy-page-error-message">{error}</div>}
        {policyContent && !loading && (
          <div dangerouslySetInnerHTML={{ __html: policyContent }} />
        )}
      </div> 
    </section>
  );
}

export default PricingPolicy;

